import { CSSProperties } from 'react';
import '../../../../font.css';
import FitPricePrimary from './FitPricePrimary';
import FitPriceSecondary from './FitPriceSecondary';
import FitPriceOld from './FitPriceOld';
export interface FitPriceProps {
  text?: string;
  width?: number;
  height?: number;
  matrix?: number[];
  top?: number;
  left?: number;
  right?: number;
  color?: [number, number, number];
  textAlign?: CSSProperties['textAlign'];
  display?: CSSProperties['display'];
  margin?: CSSProperties['margin'];
  fontFamily?: CSSProperties['fontFamily'];
  fontWeight?: CSSProperties['fontWeight'];
  variant?: 'primary' | 'secondary' | 'secondaryOld' | 'primaryOld';
  params?: Array<string | number>;
  alignItems?: CSSProperties['alignItems'];
  borderRadius?: CSSProperties['borderRadius'];
}

const FitPrice = (props: FitPriceProps) => {
  switch (props.variant ?? 'primary') {
    case 'primary':
      return <FitPricePrimary {...props} />;
    case 'secondary':
      return <FitPriceSecondary {...props} />;
    case 'primaryOld':
      return <FitPriceOld {...props} />;
    case 'secondaryOld':
      return <FitPriceSecondary {...props} />;
  }
};

export default FitPrice;
